import { render, staticRenderFns } from "./SupplierNav.vue?vue&type=template&id=36867bcc&"
import script from "./SupplierNav.vue?vue&type=script&lang=js&"
export * from "./SupplierNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports